// src/components/Headline.jsx
import React from 'react';
import styled from 'styled-components';

const StyledHeadline = styled.h1.withConfig({
  shouldForwardProp: (prop) => prop !== 'center'
})`
  color: ${({ theme, color }) => color || theme.colors.text};
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  font-size: ${({ size }) => size || '2rem'};
  margin: ${({ margin }) => margin || '0 0 1rem'};
`;

function Headline({ children, level = 1, center = false, color, size, margin }) {
  const Tag = `h${level}`; 
  return (
    <StyledHeadline as={Tag} center={center} color={color} size={size} margin={margin}>
      {children}
    </StyledHeadline>
  );
}

export default Headline;
